import BottomNav from '@/components/bottom-nav';
import Header from '@/components/header';
import { useFirebaseAuth } from '@/contexts/FirebaseAuthContext';
import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { cn } from '@/lib/utils';

const MobileLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const scrollRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [pathname]);
  const { user, loading } = useFirebaseAuth();

  const isDetailPage =
    pathname.match(/^\/propribid\/[^/]+$/) ||
    pathname.match(/^\/proprimarket\/[^/]+$/) ||
    pathname.match(/^\/proprivoucher\/[^/]+$/) ||
    pathname.match(/^\/propribox\/[^/]+$/) ||
    pathname.match(/^\/profile\/[^/]+/) ||
    pathname.match(/^\/my-auctions/);

  const showNavigation = pathname !== '/login' && !loading && !!user && !isDetailPage;

  return (
    <>
      <div className='w-full md:bg-slate-900 flex items-center justify-center font-sans overflow-hidden'>
        <div className='w-full md:max-w-[430px] h-dvh bg-white relative md:shadow-2xl overflow-hidden flex flex-col'>
          <Header />
          <div ref={scrollRef} className={cn('flex-1 overflow-y-auto scrollbar-hide', showNavigation && 'pb-20')}>
            {children}
          </div>
        </div>
      </div>
      {showNavigation && (
        <div className='fixed bottom-0 left-0 w-full z-50 pointer-events-none '>
          <div className='pointer-events-auto w-full md:max-w-[430px] mx-auto bg-white'>
            <BottomNav />
          </div>
        </div>
      )}
    </>
  );
};

export default MobileLayout;
